import { render, staticRenderFns } from "./PpvChip.vue?vue&type=template&id=c7b7fefe&scoped=true"
import script from "./PpvChip.vue?vue&type=script&lang=js"
export * from "./PpvChip.vue?vue&type=script&lang=js"
import style0 from "./PpvChip.vue?vue&type=style&index=0&id=c7b7fefe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b7fefe",
  null
  
)

export default component.exports